import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import { FaUser, FaEnvelope, FaLock, FaCheck, FaBuilding, FaUsers, FaChartLine, FaPhone, FaBriefcase, FaUserTie } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axiosClient from '../../services/axiosClient';
import { IMAGES } from '../constants/theme';
import '../assets/scss/pages/_auth.scss';
import './ModernRegister.css';

const Register = () => {
  const [userType, setUserType] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    acceptTerms: false,
    acceptMarketing: false
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Debug form data
    console.log('Form data:', formData);
    console.log('User type:', userType);
    console.log('Password:', formData.password);
    console.log('Confirm Password:', formData.confirmPassword);
    console.log('Accept Terms:', formData.acceptTerms);
    
    if (!userType) {
      alert('Veuillez sélectionner votre type de profil');
      return;
    }
    
    if (!formData.password || formData.password.length < 6) {
      alert('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }
    
    if (!formData.confirmPassword) {
      alert('Veuillez confirmer votre mot de passe');
      return;
    }
    
    if (formData.password !== formData.confirmPassword) {
      alert(`Le champ de confirmation mot de passe ne correspond pas.\nMot de passe: "${formData.password}"\nConfirmation: "${formData.confirmPassword}"`);
      return;
    }
    
    if (!formData.acceptTerms) {
      alert('Le champ conditions doit être accepté.');
      return;
    }

    // Map userType to user_type_id: 1 = Employeur, 2 = Demandeur d'emploi
    const user_type_id = userType === 'employer' ? 1 : 2;
    
    const registrationData = {
      name: formData.name.trim(),
      email: formData.email.trim().toLowerCase(),
      phone: `+221${formData.phone}`,
      phone_country: '221',
      user_type_id: user_type_id,
      password: formData.password,
      password_confirmation: formData.confirmPassword,
      accept_terms: formData.acceptTerms
    };

    try {
      console.log('Submitting registration:', registrationData);
      
      const response = await axiosClient.post('/users', registrationData, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
      
      console.log('Response status:', response.status);
      console.log('Response data:', response.data);

      console.log('Registration successful:', response.data);
      alert('Inscription réussie ! Vous pouvez maintenant vous connecter.');
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
        acceptTerms: false,
        acceptMarketing: false
      });
      setUserType('');
      
    } catch (error) {
      console.error('Registration error:', error);
      console.error('Error response:', error.response?.data);
      
      if (error.response) {
        // Server responded with error status
        if (error.response.status === 422) {
          // Validation errors
          const errors = error.response.data?.errors || error.response.data;
          console.log('Validation errors:', errors);
          
          if (typeof errors === 'object') {
            const errorMessages = Object.values(errors).flat().join('\n');
            alert(`Erreurs de validation:\n${errorMessages}`);
          } else {
            alert(`Erreur de validation: ${error.response.data?.message || 'Données invalides'}`);
          }
        } else {
          const errorMessage = error.response.data?.message || 'Erreur lors de l\'inscription';
          alert(`Erreur: ${errorMessage}`);
        }
      } else if (error.request) {
        // Request was made but no response received
        alert('Erreur de connexion au serveur');
      } else {
        // Something else happened
        alert('Une erreur inattendue s\'est produite');
      }
    }
  };

  return (
    <div className="modern-register-page">
      <div className="register-background">
        <div className="background-pattern"></div>
        <div className="background-gradient"></div>
      </div>
      
      <Container fluid className="register-container">
        <Row className="min-vh-100 align-items-center">
          {/* Left Column - Form */}
          <Col lg={7} xl={6} className="register-form-column">
            <div className="register-form-wrapper">
              {/* Header */}
              <div className="register-header">
                <div className="logo-container">
                  <img 
                    src="https://res.cloudinary.com/dihtuaq6d/image/upload/v1760187144/xrk9fhrhbahbkvjzy1db.jpg" 
                    alt="SenOffre" 
                    className="register-logo" 
                  />
                </div>
                <div className="register-title-section">
                  <span className="register-badge">
                    <FaUser className="badge-icon" />
                    Créer votre compte
                  </span>
                  <h1 className="register-title">
                    C'est rapide et facile.
                    <div className="title-decoration"></div>
                  </h1>
                  <p className="register-subtitle">
                    Rejoignez notre communauté et découvrez de nouvelles opportunités
                  </p>
                </div>
              </div>

              {/* User Type Selection */}
              <div className="user-type-section">
                <h3 className="section-title">Vous êtes un(e) :</h3>
                <div className="user-type-options">
                  <label className={`user-type-card ${userType === 'jobseeker' ? 'selected' : ''}`}>
                    <input
                      type="radio"
                      name="userType"
                      value="jobseeker"
                      checked={userType === 'jobseeker'}
                      onChange={(e) => setUserType(e.target.value)}
                      className="user-type-input"
                    />
                    <div className="user-type-content">
                      <div className="user-type-icon jobseeker">
                        <FaUserTie />
                      </div>
                      <div className="user-type-info">
                        <h4>Consultant</h4>
                        <p>Recherchez et postulez aux Appels d'offres</p>
                      </div>
                    </div>
                    <div className="selection-indicator">
                      <FaCheck />
                    </div>
                  </label>

                  <label className={`user-type-card ${userType === 'employer' ? 'selected' : ''}`}>
                    <input
                      type="radio"
                      name="userType"
                      value="employer"
                      checked={userType === 'employer'}
                      onChange={(e) => setUserType(e.target.value)}
                      className="user-type-input"
                    />
                    <div className="user-type-content">
                      <div className="user-type-icon employer">
                        <FaBriefcase />
                      </div>
                      <div className="user-type-info">
                        <h4>Entreprise</h4>
                        <p>Publiez des offres et trouvez des talents</p>
                      </div>
                    </div>
                    <div className="selection-indicator">
                      <FaCheck />
                    </div>
                  </label>
                </div>
              </div>

              {/* Registration Form */}
              <Form onSubmit={handleSubmit} className="register-form">
                <div className="form-row">
                  <div className="modern-form-group">
                    <div className="input-wrapper">
                      <FaUser className="input-icon" />
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Nom"
                        className="modern-input"
                        required
                      />
                      <label className="input-label">Nom *</label>
                    </div>
                  </div>
                </div>

                <div className="form-row">
                  <div className="modern-form-group">
                    <div className="input-wrapper">
                      <FaEnvelope className="input-icon" />
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Adresse email"
                        className="modern-input"
                        required
                      />
                      <label className="input-label">Email *</label>
                    </div>
                  </div>
                </div>

                <div className="form-row">
                  <div className="modern-form-group">
                    <div className="input-wrapper">
                      <FaPhone className="input-icon" />
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        placeholder="784310088"
                        className="modern-input"
                        pattern="[0-9]{9}"
                        maxLength="9"
                        required
                      />
                      <label className="input-label">Téléphone *</label>
                    </div>
                    <div className="phone-hint">
                      <small>Format: 7812345678 (9 chiffres)</small>
                    </div>
                  </div>
                </div>


                <div className="form-row">
                  <div className="modern-form-group">
                    <div className="input-wrapper">
                      <FaLock className="input-icon" />
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        placeholder="Mot de passe"
                        className="modern-input"
                        required
                      />
                      <label className="input-label">Mot de passe *</label>
                      <button type="button" className="password-toggle" onClick={togglePassword}>
                        <i className={showPassword ? "fa-regular fa-eye-slash" : "fa-regular fa-eye"}></i>
                      </button>
                    </div>
                    <div className="password-strength">
                      <span className="strength-text">Au moins 6 caractères</span>
                    </div>
                  </div>
                </div>

                <div className="form-row">
                  <div className="modern-form-group">
                    <div className="input-wrapper">
                      <FaLock className="input-icon" />
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                        placeholder="Confirmation Mot de passe"
                        className="modern-input"
                        required
                      />
                      <label className="input-label">Confirmation Mot de passe</label>
                      <button type="button" className="password-toggle" onClick={toggleConfirmPassword}>
                        <i className={showConfirmPassword ? "fa-regular fa-eye-slash" : "fa-regular fa-eye"}></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="form-checkboxes">
                  <label className="modern-checkbox">
                    <input
                      type="checkbox"
                      name="acceptTerms"
                      checked={formData.acceptTerms}
                      onChange={handleInputChange}
                      required
                    />
                    <div className="checkbox-custom">
                      <FaCheck />
                    </div>
                    <span className="checkbox-text">
                      J'ai lu et j'accepte les <Link to="/terms" className="link-primary">Termes & Conditions</Link> d'utilisation
                    </span>
                  </label>

                  <label className="modern-checkbox">
                    <input
                      type="checkbox"
                      name="acceptMarketing"
                      checked={formData.acceptMarketing}
                      onChange={handleInputChange}
                    />
                    <div className="checkbox-custom">
                      <FaCheck />
                    </div>
                    <span className="checkbox-text">
                      J'accepte de recevoir des e-mails marketing
                    </span>
                  </label>
                </div>

                <button type="submit" className="register-submit-btn">
                  <span>S'inscrire</span>
                  <i className="fa-solid fa-arrow-right"></i>
                </button>

                <div className="login-link">
                  <p>Déjà inscrit ? <Link to="/login" className="link-primary">Se connecter</Link></p>
                </div>
              </Form>
            </div>
          </Col>

          {/* Right Column - Features */}
          <Col lg={5} xl={6} className="register-features-column">
            <div className="features-content">
              <div className="features-header">
                <div className="features-badge">
                  <FaBuilding className="badge-icon" />
                  Publier une offre
                </div>
                <h2 className="features-title">
                  Avez-vous un avis d'appel d'offre ou un poste à pourvoir au sein de votre entreprise?
                </h2>
                <p className="features-subtitle">
                  Trouvez le bon candidat en quelques clics sur SenOffre.
                </p>
              </div>

              <div className="features-list">
                <div className="feature-card">
                  <div className="feature-icon">
                    <FaBuilding />
                  </div>
                  <div className="feature-content">
                    <h4>Gérer vos annonces</h4>
                    <p>Devenez un employeur ou une entreprise fiable. Créez et gérez vos annonces. Republiez une de vos anciennes annonces, etc.</p>
                  </div>
                </div>

                <div className="feature-card">
                  <div className="feature-icon">
                    <FaUsers />
                  </div>
                  <div className="feature-content">
                    <h4>Créez votre liste de favoris.</h4>
                    <p>Créez votre liste de favoris. Enregistrez vos recherches. Ne ratez aucune bonne affaire!</p>
                  </div>
                </div>
              </div>

              <div className="features-stats">
                <div className="stat-item">
                  <div className="stat-number">500+</div>
                  <div className="stat-label">offres disponibles</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">50+</div>
                  <div className="stat-label">entreprises</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">20+</div>
                  <div className="stat-label">secteurs</div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Register;
